<template>
    <v-list-tile  class="runner-fields" @click="">
            <v-list-tile-content>
              <div v-if="editable" class="full_width">
              <slot :error="validation.hasError('value')" :error-messages="validation.allErrors('value')" :label="label">
                <v-text-field
                              type="text"
                              :label="label + (required ? '*' : '')"
                              :value="value"
                              @input="onInput"
                              :error="validation.hasError('value')"
                              :error-messages="validation.allErrors('value')"
                              v-bind="props"
                />
              </slot>
              </div>
              <v-list-tile-sub-title v-if="description && editable">{{ description}}</v-list-tile-sub-title>
              <v-list-tile-sub-title v-if="!editable">{{label}}</v-list-tile-sub-title>
              <v-list-tile-title style="white-space: pre-wrap;" v-if="!editable"><slot name="value" :value="objValue">{{objValue}}</slot></v-list-tile-title>
            </v-list-tile-content>
    </v-list-tile>
</template>

<script>
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'

export default {
  validators: {
    'value': function (value) {
      value = value || null
      return Validator.value(value).custom(serverValidation(this.formErrors, this.field))
    }
  },
  props: {
    props: {
      type: Object,
      default: function () {
        return {}
      }
    },
    value: {},
    objValue: {},
    label: {type: String},
    description: {type: String},
    editable: {type: Boolean},
    required: {type: Boolean},
    field: {type: String},
    placeholder: {type: String},
    inputId: {type: String},
    formErrors: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    'formErrors': function (oldVar, newVar) {
      this.$validate()
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style>
.full_width {
  width: 100%;
}
.runner-fields .v-list__tile--link.v-list__tile {
  min-height: 72px;
  height: auto;
}
.runner-fields .v-list__tile__content {
  min-height: 72px;
  height: auto;
}
.runner-fields .v-list__tile__title {
  height: auto;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerDataField.vue